// Drummond deck palette (CLAUDE.md) and the colour helpers used by the grid and charts.
export const NAVY = '#012341';
export const TEAL = '#337B91';
export const SLATE = '#5E819C';
export const TEAL_DARK = '#12706C';
export const SAGE = '#A6C6C1';
export const MAUVE = '#AA8090';
export const LIGHT_BLUE = '#BBCBD7';
export const AMBER = '#FBAE40';
export const CORAL = '#F26B43';
export const PILLAR_COLOURS = [SLATE, TEAL, SAGE, MAUVE, TEAL_DARK, LIGHT_BLUE];

export const pillarColour = (i) => PILLAR_COLOURS[i % PILLAR_COLOURS.length];

// Heat shading for a value cell by its cohort percentile (teal, stronger = better).
export function heatStyle(pct, on) {
  if (!on || pct === null || pct === undefined) return undefined;
  const a = 0.06 + (Math.max(0, Math.min(100, pct)) / 100) * 0.34;
  return { background: `rgba(51, 123, 145, ${a.toFixed(3)})` };
}
